import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import { AgGridReact } from 'ag-grid-react';
import {
  Document,
  Image,
  Page,
  StyleSheet,
  Text,
  View,
  pdf,
} from '@react-pdf/renderer';
import axios from 'axios';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Button, Card, CardBody, Col, Row } from 'reactstrap';
import { API_URL, baseUrl, getAgreementDocument } from '../../api';
import {
  getAgreementsListReq,
  getClientWithIdReq,
  getAgreementReq
} from '../../service/clientService';
import { changePreloader, setBreadcrumbItems } from '../../store/actions';
import { formatDate } from '../../utility/formatDate';
import AgreementCard from './AgreementCard';
import getPaymentTerm from '../../utility/getPaymentTerm';
import { getTaxesReq } from '../../service/itemService';

const styles = StyleSheet.create({
  page: {
    padding: 30,
  },
  title: {
    fontSize: 14,
    fontWeight: 'bold',
    paddingVertical: 10,
  },
  section: {
    margin: 10,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    gap: 4,


  },
  addressSection: {
    margin: 10,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    gap: 12,

  },
  address: {
    width: '49%',
  },
  table: {
    display: 'table',
    width: '100%',
    marginTop: 0,
    marginBottom: 0,
  },
  tableRow: {
    flexDirection: 'row',
  },
  tableCol: {
    width: '10%',
    flex: 1,
    borderStyle: 'solid',
    borderWidth: 1,
    padding: 5,
    borderColor: 'gray'
  },
  pageBorder: {
    position: 'absolute',
    top: 30,
    right: 30,
    bottom: 30,
    left: 30,
    borderWidth: 1,
    borderColor: 'gray'
  },
  firstCol: {
    width: '6%',
    borderStyle: 'solid',
    borderWidth: 1,
    padding: 5,
    borderColor: 'gray'
  },
  titleCol: {
    width: '60%',
    borderStyle: 'solid',
    borderWidth: 1,
    padding: 5,
    borderColor: 'gray'
  },
  tableCell: {
    fontSize: 8,
    textAlign: 'center',
  },
  header: {
    fontSize: 10,
    fontWeight: 'bold',
  },
  info: {
    fontSize: 9,
  },
  divider: {
    borderBottomWidth: 0.5,
    borderBottomColor: 'black',
    marginVertical: 10,
  },
  logoImage: {
    height: 60,
    width: 100,
  },
  amtCard: {
    width: '40%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: 3,
    backgroundColor: '#58db83',
    borderRadius: '10px',
    color: 'white',
    fontSize: '14px',
    fontWeight: 'bold',
    textAlign: 'center',
  },
  amtText: {
    textAlign: 'center',
    fontSize: '12px',
    fontWeight: 'bold',
  },
});

// Function to display table with pagination
const TableWithPagination = ({ data }) => {
  return (
    <View>
      {/* Table Header */}
      <View style={styles.tableRow} fixed>
        <View style={[styles.firstCol, { borderRight: 0, backgroundColor: '#D3D3D3' }]}>
          <Text style={[styles.tableCell, styles.header]}>#</Text>
        </View>
        <View style={[styles.titleCol, { borderRight: 0, backgroundColor: '#D3D3D3' }]}>
          <Text style={[styles.tableCell, styles.header, { textAlign: 'left' }]}>Item Name</Text>
        </View>
        <View style={[styles.tableCol, { borderRight: 0, backgroundColor: '#D3D3D3' }]}>
          <Text style={[styles.tableCell, styles.header, { textAlign: 'left' }]}>Unit</Text>
        </View>

        <View style={[styles.tableCol, { borderRight: 0, backgroundColor: '#D3D3D3' }]}>
          <Text style={[styles.tableCell, styles.header, { textAlign: 'left' }]}>Tax</Text>
        </View>
        <View style={[styles.tableCol, { backgroundColor: '#D3D3D3' }]}>
          <Text style={[styles.tableCell, styles.header, { textAlign: 'left' }]}>
            Price
          </Text>
        </View>

      </View>

      {/* Table Rows */}
      {data.map((item, index) => (
        <View style={styles.tableRow} key={index} wrap={false}>
          <View style={[styles.firstCol, { borderRight: 0, borderTop: 0 }]}>
            <Text style={styles.tableCell}>{index + 1}</Text>
          </View>
          <View style={[styles.titleCol, { borderRight: 0, borderTop: 0 }]}>
            <Text style={[styles.tableCell, { textAlign: 'left' }]}>
              {item.title}
            </Text>
          </View>
          <View style={[styles.tableCol, { borderRight: 0, borderTop: 0 }]}>
            <Text style={[styles.tableCell, { textAlign: 'left' }]}>
              {item.unit}
            </Text>
          </View>
          <View style={[styles.tableCol, { borderRight: 0, borderTop: 0 }]}>
            <Text style={[styles.tableCell, { textAlign: 'right' }]}>
              {`${(item.tax?.match(/\d+(\.\d+)?/g) || [])
                .reduce((sum, num) => sum + parseFloat(num), 0)} %`}
            </Text>
          </View>
          <View style={[styles.tableCol, { borderTop: 0 }]}>
            <Text style={[styles.tableCell, { textAlign: 'right' }]}>
              {item.sellingPrice}
            </Text>
          </View>
        </View>
      ))}
    </View>
  );
};

// Define the PDF document structure
const PdfDocument = ({ data }) => {
  return (
    <Document>
      <Page size="A4" style={styles.page} wrap>
        <View style={styles.pageBorder} fixed />
        {data?.isDeleted === true && (
          <View
            style={{
              position: 'absolute',
              top: '60%',
              left: 0,
              right: 0,
              textAlign: 'center',
              transform: 'rotate(-45deg)',
              opacity: 0.15,
            }}
          >
            <Text style={{ fontSize: 60, fontWeight: 'bold' }}>
              INACTIVE
            </Text>
          </View>
        )}
        <View style={{ borderWidth: '1', borderColor: 'gray', borderBottom: 0 }}>
          <View style={[styles.section, { alignItems: 'center' }]}>

            <View style={[styles.address, { width: '25% !important', }]}>
              <Image
                src={require('../../assets/images/Willsmeet-Logo.png')}
                style={styles.logoImage}
              />
            </View>
            <View style={[styles.address, { width: '50% !important' }]}>
              <Text style={styles.header}>
                Bansi Office Solutions Private Limited
              </Text>
              <Text style={styles.info}>
                #1496, 19th Main Road, Opp Park Square Apartment, HSR Layout,
                Bangalore Karnataka 560102, India
              </Text>
              <Text style={styles.info}>
                Web: www.willsmeet.com, Email:sales@willsmeet.com
              </Text>
            </View>
          </View>

          <View>
            <Text style={[styles.title, { textAlign: 'center' }]}>
              AGREEMENT DETAILS
            </Text>
          </View>


          <View style={[styles.section, { paddingVertical: 10 }]}>
            <View>
              <Text style={[styles.info, { paddingVertical: 4, fontWeight: 'bold' }]}>
                <Text>Name:</Text> {data?.client?.name}
              </Text>
              <Text style={[styles.info, { paddingVertical: 4 }]}>
                <Text style={{ fontWeight: 'bold' }}>Email:</Text> {data?.client?.email}
              </Text>
              <Text style={[styles.info, { paddingVertical: 4 }]}>
                <Text style={{ fontWeight: 'bold' }}>Contact: </Text> {data?.client?.contact}
              </Text>
              <Text style={[styles.info, { paddingVertical: 4 }]}>
                <Text style={{ fontWeight: 'bold' }}>Agreement Date: </Text>{formatDate(data.createdAt)}
              </Text>
              <Text style={[styles.info, { paddingTop: 4 }]}>
                <Text style={{ fontWeight: 'bold' }}>Payment Terms:</Text> {getPaymentTerm(data.paymentTerms)}
              </Text>
            </View>
          </View>
        </View>

        <View style={styles.table}>
          <View style={{ borderWidth: 1, borderColor: 'gray', borderBottom: 0, borderTop: 0 }}>
            <Text style={[styles.header, { paddingBottom: 10, marginLeft: 10 }]}>
              Agreement Items
            </Text>
          </View>
          <TableWithPagination data={data.items} />
        </View>
        <Text
          fixed
          style={{
            position: 'absolute',
            bottom: 15,
            left: 0,
            right: 30,
            fontSize: 8,
            textAlign: 'right',
          }}
          render={({ pageNumber,totalPages }) =>
            totalPages>1?`${pageNumber}`:''
          }
        />
      </Page>
    </Document >
  );
};

const PastAgreements = (props) => {
  document.title = 'Agreements';
  const navigate = useNavigate();
  const userType =
    JSON.parse(localStorage.getItem('user'))?.userType || 'client';
  const dispatch = useDispatch();
  const { clientId } = useParams();
  const gridRef = useRef();
  const [rowData, setRowData] = useState([]);
  const [paginationPageSize, setPaginationPageSize] = useState(25);
  const [page, setPage] = useState(1);
  const [clientName, setClientName] = useState('');

  const handleDownload = async (agreementId) => {
    try {
      const res = await getAgreementReq({ agreementId });
      const agreement = res?.payload?.agreement;
      

      if (!agreement) {
        toast.error("Agreement not found");
        return;
      }

      const clientRes = await getClientWithIdReq({
        _id: agreement.clientId
      
      });
    
    
      const taxRes = await getTaxesReq();
      const taxes = taxRes?.payload?.taxes || [];
      console.log(taxRes)
      

      const client = clientRes?.payload?.client || {};


      const items = agreement.items.map((item) => {
        const variant = item.variants?.[0];
        const taxName = taxes.find(
          (t) => t._id === item.item.taxes[0]?.taxId
        )?.name;


      
        return {
          title: item?.alternateItemTitle,
          sellingPrice: variant?.price,
          tax: taxName,
          unit: item.item.itemUnit,
        };
      });

      handleOpenPdf({
        client,
        ...agreement,
        items,
      });

    } catch (error) {
      console.error(error);
      toast.error("Failed to fetch agreement");
    }
  };
  const handleOpenPdf = async (data) => {
    try {
      if (!data) {
        toast.error("No agreement data found");
        return;
      }

      const doc = <PdfDocument data={data} />;

      const blob = await pdf(doc).toBlob();

      if (!blob) {
        toast.error("PDF generation failed");
        return;
      }

      const url = URL.createObjectURL(blob);

      window.open(url, "_blank");

      setTimeout(() => URL.revokeObjectURL(url), 1000);
    } catch (error) {
      console.error("PDF generation failed:", error);
      toast.error("PDF generation failed");
    }
  };
  useEffect(() => {
    if (!clientName) return;

    let breadcrumbs = [];

    if (userType === 'admin') {
      breadcrumbs = [
        { title: 'Dashboard', link: '/dashboard' },
        { title: 'Clients', link: '/clients' },
        { title: clientName, link: `/client/${clientId}` },
        { title: 'Agreements', link: '#' },
      ];
    } else {
      breadcrumbs = [
        { title: 'Dashboard', link: '/dashboard' },
        { title: 'Agreements', link: '#' },
      ];
    }

    props.setBreadcrumbItems('Agreements', breadcrumbs);
  }, [clientName, userType]);

  const columnDefs = [
    {
      headerName: 'Agreement Version',
      field: 'version',
      minWidth: 150,
      cellRenderer: (params) => `V${params.value}`,
    },
    {
      headerName: 'Created Date',
      field: 'createdAt',
      minWidth: 150,
      suppressMenu: true,
      floatingFilterComponentParams: { suppressFilterButton: true },
      cellRenderer: (params) => {
        if (params.value) {
          const date = new Date(params.value);
          return <>{formatDate(date)}</>;
        }
        return '-';
      },
    },
    {
      headerName: 'Validity',
      field: 'validity',
      minWidth: 150,
      suppressMenu: true,
      floatingFilterComponentParams: { suppressFilterButton: true },
      cellRenderer: (params) => {
        if (params.value) {
          const date = new Date(params.value);
          return <>{formatDate(date)}</>;
        }
        return '-';
      },
    },
    {
      headerName: 'Status',
      field: 'isDeleted',
      minWidth: 130,
      suppressMenu: true,
      cellRenderer: (params) => {
        if (params.value === true) {
          return <span className="text-danger fw-semibold">Inactive</span>;
        }
        if (params.value === false) {
          return <span className="text-success fw-semibold">Active</span>;
        }
        return '-';
      },
    },
    {
      headerName: "Action",
      field: "action",
      sortable: false,
      width: 180,
      cellRenderer: (params) => {
        if (!params.data?._id) return null;

        return (
          <Button
            color="primary"
            size="sm"
            onClick={() => handleDownload(params.data._id, clientId)}
          >
            <i className="mdi mdi-download me-1"></i>
            Download
          </Button>
        );
      },
    }];
  const autoSizeStrategy = {
    type: 'fitGridWidth',
  };

  const pagination = true;
  

  const getClientData = async () => {
    try {
      const data = { _id: clientId };
      const res = await getClientWithIdReq(data);
      if (res.payload?.client) {
        setClientName(res.payload.client.name);
      }
    } catch (error) {
      console.error('Error fetching client data:', error);
    }
  };

  const getListOfRowData = useCallback(
    async (body) => {
      if (rowData[(page - 1) * paginationPageSize]) {
        return;
      }

      dispatch(changePreloader(true));

      try {
        const response = await getAgreementsListReq(body);

        const agreements = response?.payload?.list || [];
    

        const emptyObjects = Array.from(
          { length: paginationPageSize },
          () => null
        );

        let filledRows;

        if (agreements.length < paginationPageSize) {
          filledRows = [...agreements];
        } else {
          filledRows = [...agreements, ...emptyObjects];
        }

        const newData = [...rowData];

        newData.splice(
          (page - 1) * paginationPageSize,
          paginationPageSize,
          ...filledRows
        );

        setRowData(newData);
        
      } catch (error) {
        toast.error('Failed to fetch agreements');
      } finally {
        dispatch(changePreloader(false));
      }
    },
    [page, paginationPageSize]
  );
  useEffect(() => {
    if (clientId) {
      getListOfRowData({
        clientId,
        page: page,
        limit: paginationPageSize,
      });
    }
  }, [clientId, page, paginationPageSize]);

  const onPaginationChanged = useCallback(() => {
    const pageSize = gridRef.current.api.paginationGetPageSize();

    if (pageSize !== paginationPageSize) {
      setPaginationPageSize(pageSize);
    }

    const newPage =
      gridRef.current.api.paginationGetCurrentPage() + 1;

    if (page !== newPage) {
      setPage(newPage);
    }
  }, [page, paginationPageSize]);

  return (
    <React.Fragment>
      <div className="page-content" style={{ paddingTop: '10px' }}>
        <div style={{ width: "320px" }}>
          <AgreementCard clientId={clientId} compact />
        </div>
        <div className="container-fluid">
          <Row>
            <Col className="col-12 px-0">
              <Card style={{ padding: "10px" }}>
                <CardBody>
                  <div style={{ height: '600px', width: '100%' }}>
                    <AgGridReact
                      ref={gridRef}
                      rowData={rowData}
                      columnDefs={columnDefs}
                      pagination={true}
                      paginationPageSize={paginationPageSize}
                      onPaginationChanged={onPaginationChanged}
                      defaultColDef={{
                        sortable: true,
                        resizable: true,
                        flex: 1,
                      }}
                      className="ag-theme-quartz"
                    />
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {};
};

export default connect(mapStateToProps, { setBreadcrumbItems })(PastAgreements);



